import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=4e6b8792&"
import script from "./Payroll.vue?vue&type=script&lang=js&"
export * from "./Payroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports